import { Component } from '@angular/core';

@Component({
  selector: 'app-wide-sidebar',
  imports: [],
  templateUrl: './wide-sidebar.component.html',
  styleUrl: './wide-sidebar.component.scss'
})
export class WideSidebarComponent {

}
